export default "__VITE_ASSET__55f1f7d0__"